var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32 2.45c-2.39-1.17-4.35.02-4.35 2.64v14.84c0 1.14.95 2.07 2.11 2.07h7.42c.55 0 1-.45 1-1V7.41c0-1.05-.79-2.3-1.75-2.77L6.32 2.45zm-.82 11.3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.47a.749.749 0 1 1 0 1.5H5.5zm0-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.47a.749.749 0 1 1 0 1.5H5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5a2.5 2.5 0 0 1-2.5 2.5h-4.53c-.54 0-.97-.43-.97-.97v-2.16c1.07.13 2.2-.18 3.01-.83.68.55 1.55.88 2.5.88.93 0 1.8-.33 2.49-.88v1.46zM22 15.06a2.5 2.5 0 0 1-2.49 2.36 2.5 2.5 0 0 1-2.5-2.5c0 1.53-1.41 2.76-3.01 2.45V12c0-.64.59-1.12 1.22-.98l1.79.4.48.11 2.04.46c.49.1.94.27 1.33.52 0 .007.003.01.01.01.1.07.2.15.29.24.46.46.76 1.13.83 2.11 0 .06.01.12.01.18v.01z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBuilding);
export default __webpack_public_path__ + "static/media/vuesax-bold-building.e53dc38e5c4885454505a31047d97f6c.svg";
export { ForwardRef as ReactComponent };